import React from 'react';

import PhotoAlbumIcon from '@mui/icons-material/PhotoAlbum';
import { Box, IconButton } from '@mui/material';

import ProgressWithLabel from '@common/components/ProgressWithLabel';

import FileWithProgress from '../../types/fileWithProgress';
import {
	UploadedFileListItemDeleteIcon,
	UploadedFileListItemLink,
	UploadedFileListItemText,
	UploadedFileListItemWrap,
} from './style';

interface PropsType {
	file: FileWithProgress;
	handleDelete: (file: File | string) => void;
}

function UploadedFileListItem({ file, handleDelete }: PropsType) {
	if (!file) return null;

	const showProgressBar = !!file?.progress && !file.url;
	const error = file?.error;
	const errorStyle = error && { color: '#FF0000' };

	return (
		<UploadedFileListItemWrap>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: '12px',
					width: '100%',
				}}
			>
				<PhotoAlbumIcon sx={{ fontSize: '24px', ...errorStyle }} />
				<Box width="100%">
					<Box display="flex" alignItems="center" gap="12px">
						<UploadedFileListItemText sx={errorStyle}>{file.name}</UploadedFileListItemText>
						{file.url && (
							<UploadedFileListItemLink href={file?.url} target="_blank">
								Preview
							</UploadedFileListItemLink>
						)}
						<IconButton onClick={() => handleDelete(file.file || file?.url)}>
							<UploadedFileListItemDeleteIcon isError={!!error} />
						</IconButton>
					</Box>
					{showProgressBar && <ProgressWithLabel value={file.progress} />}
					{error && (
						<UploadedFileListItemText sx={{ maxWidth: '100%', ...errorStyle }}>
							{error}
						</UploadedFileListItemText>
					)}
				</Box>
			</Box>
		</UploadedFileListItemWrap>
	);
}

export default UploadedFileListItem;
